/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BehaviorBipInfoScreenDataModel } from '../../models/behavior-bip-info-screen-data-model';

export interface GetBehaviorBipInfoScreenData$Params {
  patientID?: number;
  patientBehaviorID?: number;
}

export function GetBehaviorBipInfoScreenData(http: HttpClient, rootUrl: string, params?: GetBehaviorBipInfoScreenData$Params, context?: HttpContext): Observable<StrictHttpResponse<BehaviorBipInfoScreenDataModel>> {
  const rb = new RequestBuilder(rootUrl, GetBehaviorBipInfoScreenData.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('patientBehaviorID', params.patientBehaviorID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BehaviorBipInfoScreenDataModel>;
    })
  );
}

GetBehaviorBipInfoScreenData.PATH = '/api/Staff/GetBehaviorBipInfoScreenData';
